import axios from "axios";

export async function getThumbnail(url: string) {
  const isYoutube = isYouTubeVideo(url);

  if (isYoutube) {
    return getYouTubeThumbnail(url);
  } else if (isYouTubeShorts(url)) {
    return getYouTubeShortsThumbnail(url);
  } else if (isYouTubeLive(url)) {
    return getYouTubeLiveThumbnail(url);
  } else {
    return getVimeoThumbnail(url);
  }
}

function getYouTubeThumbnail(url: string) {
  const youtubeId = getYoutubeId(url);

  if (youtubeId) {
    return "http://d3j30ldhbe67w5.cloudfront.net/" + youtubeId;
  }
}

function getYouTubeShortsThumbnail(url: string) {
  const shortId = getYouTubeShortId(url);

  if (shortId) {
    return "http://d3j30ldhbe67w5.cloudfront.net/" + shortId;
  }
}

function getYouTubeLiveThumbnail(url: string) {
  const liveId = getYouTubeLiveId(url);

  if (liveId) {
    return "http://d3j30ldhbe67w5.cloudfront.net/" + liveId;
  }
}

export function getYoutubeId(url: string) {
  const regExp =
    /^.*(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\\/\n\s]+\/\S*\/|(?:v|embed|e)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11}).*/;
  const match = url.match(regExp);
  const youtubeId = match && match[1] ? match[1] : false;

  return youtubeId;
}

function getYouTubeShortId(url: string) {
  const regex = /youtube\.com\/shorts\/([a-zA-Z0-9_-]+)/;
  const match = url.match(regex);
  return match ? match[1] : false;
}

function getYouTubeLiveId(url: string) {
  const regex = /youtube\.com\/live\/([a-zA-Z0-9_-]+)/;
  const match = url.match(regex);
  return match ? match[1] : false;
}

function isYouTubeVideo(url: string) {
  return !!getYoutubeId(url);
}

function isYouTubeShorts(url: string) {
  return !!getYouTubeShortId(url);
}

function isYouTubeLive(url: string) {
  return !!getYouTubeLiveId(url);
}

async function getVimeoThumbnail(url: string) {
  const regExp =
    /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
  const match = url.match(regExp);
  const vimeoId = match && match[5].length > 4 ? match[5] : false;

  if (vimeoId) {
    try {
      const data = await axios.get(
        "https://vimeo.com/api/v2/video/" + vimeoId + ".json"
      );
      return data.data[0].thumbnail_large;
    } catch (e) {
      console.error(e);
    }
  }
}
